<ngb-tabset>

  <ngb-tab *qmAuth="'LinkingMisonetComponent'" (select)="selectedTab = 'linking-misonet';" title="{{'MISONET-Linkings'}}">
    <ng-template ngbTabContent>
      <qm-linking-misonet></qm-linking-misonet>
    </ng-template>
  </ngb-tab>
  <ngb-tab *qmAuth="'LinkingVivoComponent'"  (select)="selectedTab = 'linking-vivo';" title="{{'VIVO-Linkings'}}">
    <ng-template ngbTabContent>
      <qm-linking-vivo></qm-linking-vivo>
    </ng-template>
  </ngb-tab>
  <ngb-tab *qmAuth="'LinkingValmetComponent'"  (select)="selectedTab = 'linking-valmet';" title="{{'VALMET-Linkings'}}">
    <ng-template ngbTabContent>
      <qm-linking-valmet></qm-linking-valmet>
    </ng-template>
  </ngb-tab>
</ngb-tabset>
